import { useState } from "react";
import { moodboardItems } from "../../../mocks/arHub";

export default function Moodboard() {
  const [selected, setSelected] = useState<string[]>([]);
  const [activeMood, setActiveMood] = useState<string | null>(null);

  const toggle = (id: string) => {
    setSelected((prev) => prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]);
  };

  const moods = moodboardItems.map((m) => m.mood);

  return (
    <div className="bg-[#1C1F2E] border border-[#2A2D3E] rounded-xl p-5 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-[#111111] font-semibold text-sm">무드보드</h3>
          <p className="text-[#5A5E72] text-xs mt-0.5">앨범 콘셉트 비주얼 레퍼런스</p>
        </div>
        <button className="text-xs text-[#E8375F] border border-[#E8375F]/40 px-2.5 py-1 rounded-full hover:bg-[#E8375F]/10 cursor-pointer whitespace-nowrap">
          <i className="ri-add-line mr-1"></i>이미지 추가
        </button>
      </div>

      <div className="flex gap-2 mb-3 flex-wrap">
        <button
          onClick={() => setActiveMood(null)}
          className={`text-[10px] px-2.5 py-1 rounded-full border cursor-pointer whitespace-nowrap transition-colors ${
            activeMood === null ? "border-[#E8375F] text-[#E8375F] bg-[#E8375F]/10" : "border-[#2A2D3E] text-[#8B91A8]"
          }`}
        >
          전체
        </button>
        {moods.map((m) => (
          <button
            key={m}
            onClick={() => setActiveMood(activeMood === m ? null : m)}
            className={`text-[10px] px-2.5 py-1 rounded-full border cursor-pointer whitespace-nowrap transition-colors ${
              activeMood === m ? "border-[#E8375F] text-[#E8375F] bg-[#E8375F]/10" : "border-[#2A2D3E] text-[#8B91A8]"
            }`}
          >
            {m}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-2 flex-1 overflow-y-auto">
        {moodboardItems
          .filter((item) => !activeMood || item.mood === activeMood)
          .map((item) => (
            <div
              key={item.id}
              onClick={() => toggle(item.id)}
              className={`relative rounded-xl overflow-hidden cursor-pointer group transition-all ${
                selected.includes(item.id) ? "ring-2 ring-[#E8375F]" : "ring-1 ring-[#2A2D3E]"
              }`}
              style={{ aspectRatio: "1" }}
            >
              <img
                src={item.imageUrl}
                alt={item.tag}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-2 translate-y-2 group-hover:translate-y-0 transition-transform opacity-0 group-hover:opacity-100">
                <span className="text-[10px] text-white font-medium block truncate">{item.tag}</span>
              </div>
              {selected.includes(item.id) && (
                <div className="absolute top-1.5 right-1.5 w-5 h-5 flex items-center justify-center bg-[#E8375F] rounded-full">
                  <i className="ri-check-line text-white text-[10px]"></i>
                </div>
              )}
            </div>
          ))}
      </div>

      {selected.length > 0 && (
        <div className="mt-3 px-3 py-2 bg-[#E8375F]/10 rounded-lg border border-[#E8375F]/30 text-xs text-[#E8375F]">
          <i className="ri-palette-line mr-1"></i>
          {selected.length}개 이미지 선택됨 - 앨범 기획서에 무드보드로 첨부됩니다
        </div>
      )}
    </div>
  );
}
